/* Karanja Ritual pre-order section.
   Theme-asset JS cannot contain Liquid, so every piece of per-section
   configuration arrives on data-* attributes set by the section template.

   Two things here are not obvious and should not be simplified away:

   1. The dock and the modal are position:fixed. Some themes put transform or
      contain on .shopify-section, which makes a containing block and traps
      them inside the section. So they are portalled to <body> on init.
   2. The theme editor re-renders a section on every keystroke. Without the
      shopify:section:unload teardown below you accumulate one orphaned dock
      and one leaked listener per keystroke. */
(function () {
  'use strict';

  var LOCK = 'kr-po-locked';
  var live = Object.create(null); // section id -> instance

  function sel(root, name) {
    return root.querySelector('[data-kr="' + name + '"]');
  }
  function all(root, name) {
    return Array.prototype.slice.call(
      root.querySelectorAll('[data-kr="' + name + '"]')
    );
  }

  /* ---------------------------------------------------------------- cart */

  function readJson(res) {
    return res
      .json()
      .catch(function () {
        return {};
      })
      .then(function (data) {
        if (!res.ok) {
          throw new Error(
            data.description ||
              data.message ||
              'Something went wrong. Please try again.'
          );
        }
        return data;
      });
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {})
    }).then(readJson);
  }

  /* ------------------------------------------------------------ instance */

  function Instance(container) {
    var self = this;
    var id = container.getAttribute('data-kr-section');

    this.id = id;
    this.container = container;
    this.root = container.querySelector('[data-kr-root]');
    this.portal = container.querySelector('[data-kr-portal]');
    if (!this.root || !this.portal) return;

    this.method = this.root.getAttribute('data-kr-method') || 'clear_add';
    this.cartUrl = this.root.getAttribute('data-kr-cart-url') || '/cart';
    this.routes = {
      get: this.cartUrl + '.js',
      add: this.cartUrl + '/add.js',
      clear: this.cartUrl + '/clear.js'
    };

    // Any dock/veil left in <body> by a previous render of this same section.
    Array.prototype.forEach.call(
      document.querySelectorAll(
        '[data-kr-portal][data-kr-section="' + id + '"]'
      ),
      function (node) {
        if (node !== self.portal) node.remove();
      }
    );
    document.body.appendChild(this.portal);

    this.veil = sel(this.portal, 'veil');
    this.sheet = sel(this.portal, 'sheet');
    this.dock = sel(this.portal, 'dock');
    this.viewUpsell = sel(this.portal, 'view-upsell');
    this.viewDone = sel(this.portal, 'view-done');
    this.error = sel(this.portal, 'error');

    this.lastFocus = null;
    this.observer = null;
    this.onKeydown = null;

    this.bind();
  }

  Instance.prototype.bind = function () {
    var self = this;

    all(this.portal, 'close')
      .concat(all(this.root, 'close'))
      .forEach(function (b) {
        b.addEventListener('click', self.close.bind(self));
      });

    all(this.root, 'reserve')
      .concat(all(this.portal, 'reserve'))
      .forEach(function (b) {
        b.addEventListener('click', self.open.bind(self));
      });

    var addTowel = sel(this.portal, 'add-towel');
    var skipTowel = sel(this.portal, 'skip-towel');
    if (addTowel)
      addTowel.addEventListener('click', function () {
        self.summary(true);
      });
    if (skipTowel)
      skipTowel.addEventListener('click', function () {
        self.summary(false);
      });

    // In permalink mode the confirm control is an <a href> and needs no JS.
    all(this.portal, 'checkout').forEach(function (b) {
      if (b.tagName === 'A') return;
      b.addEventListener('click', function () {
        self.reserve(b, b.getAttribute('data-kr-when') || 'ritual');
      });
    });

    this.veil.addEventListener('mousedown', function (e) {
      if (e.target === self.veil) self.close();
    });

    // Bound only while the sheet is open, so sections never fight each other.
    this.onKeydown = function (e) {
      if (e.key === 'Escape') return self.close();
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(
        self.sheet.querySelectorAll(
          'button:not([hidden]):not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        ),
        function (el) {
          return el.offsetWidth || el.offsetHeight || el.getClientRects().length;
        }
      );
      if (!f.length) return;
      var first = f[0];
      var last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    };

    // The dock rises once the page's own call to action has scrolled away.
    // The only reserve button inside the root is that primary CTA; the dock's
    // own button lives in the portal.
    var cta = sel(this.root, 'reserve');
    if (cta && this.dock && 'IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(
        function (entries) {
          self.dock.classList.toggle('kr-on', !entries[0].isIntersecting);
        },
        { rootMargin: '-10px 0px 0px 0px' }
      );
      this.observer.observe(cta);
    }
  };

  /* ------------------------------------------------------------ the sheet */

  Instance.prototype.open = function () {
    this.lastFocus = document.activeElement;
    this.hideError();

    // With no towel block configured there is nothing to upsell, so step one
    // is skipped entirely rather than shown empty.
    if (this.viewUpsell) {
      this.viewUpsell.hidden = false;
      this.viewDone.hidden = true;
      this.show('ritual');
    } else {
      this.summary(false, true);
    }

    this.veil.hidden = false;
    var veil = this.veil;
    requestAnimationFrame(function () {
      veil.classList.add('kr-on');
    });
    lock();
    document.addEventListener('keydown', this.onKeydown);
    this.sheet.scrollTop = 0;
    this.focusFirst();
  };

  Instance.prototype.close = function () {
    var veil = this.veil;
    veil.classList.remove('kr-on');
    unlock();
    document.removeEventListener('keydown', this.onKeydown);
    setTimeout(function () {
      veil.hidden = true;
    }, 270);
    if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
  };

  Instance.prototype.summary = function (withTowel, skipAnimation) {
    this.show(withTowel ? 'both' : 'ritual');
    if (this.viewUpsell) this.viewUpsell.hidden = true;
    this.viewDone.hidden = false;
    this.sheet.scrollTop = 0;
    if (!skipAnimation) this.focusFirst();
  };

  /* Both totals, both headings and both button labels are pre-rendered by
     Liquid and toggled here. Nothing in this file formats money: shop.money_format
     can contain markup, which would render literally through textContent. */
  Instance.prototype.show = function (which) {
    Array.prototype.forEach.call(
      this.portal.querySelectorAll('[data-kr-when]'),
      function (el) {
        el.hidden = el.getAttribute('data-kr-when') !== which;
      }
    );
  };

  Instance.prototype.focusFirst = function () {
    var target =
      sel(this.portal, 'add-towel') ||
      this.portal.querySelector('[data-kr="checkout"]:not([hidden])');
    var sheet = this.sheet;
    setTimeout(function () {
      if (target && target.focus) target.focus({ preventScroll: true });
      sheet.scrollTop = 0;
    }, 60);
  };

  /* -------------------------------------------------------------- reserve */

  Instance.prototype.reserve = function (button, which) {
    var self = this;
    var raw = this.root.getAttribute('data-kr-items-' + which);
    var items;
    try {
      items = JSON.parse(raw);
    } catch (e) {
      items = null;
    }
    if (!items || !items.length) {
      return this.showError('This pre-order is not available right now.');
    }

    this.busy(button, true);
    this.hideError();

    var work;
    if (this.method === 'clear_add') {
      // Snapshot first: if the add fails after the clear, the customer's cart
      // is gone unless we can put it back.
      work = fetch(this.routes.get, { headers: { Accept: 'application/json' } })
        .then(readJson)
        .then(function (cart) {
          var previous = (cart.items || []).map(function (i) {
            return {
              id: i.variant_id,
              quantity: i.quantity,
              properties: i.properties || undefined,
              selling_plan: (i.selling_plan_allocation || {}).selling_plan
                ? i.selling_plan_allocation.selling_plan.id
                : undefined
            };
          });
          return post(self.routes.clear)
            .then(function () {
              return post(self.routes.add, { items: items });
            })
            .catch(function (err) {
              if (!previous.length) throw err;
              return post(self.routes.add, { items: previous }).then(
                function () {
                  throw err;
                },
                function () {
                  throw err;
                }
              );
            });
        });
    } else {
      work = post(this.routes.add, { items: items });
    }

    work
      .then(function () {
        window.location.assign(self.checkoutUrl());
      })
      .catch(function (err) {
        self.busy(button, false);
        self.showError(err && err.message);
      });
  };

  /* There is no routes.checkout_url in Liquid, so derive it from the cart URL
     rather than hardcoding /checkout, which would drop a Markets locale prefix. */
  Instance.prototype.checkoutUrl = function () {
    return this.cartUrl.replace(/\/cart$/, '/checkout');
  };

  Instance.prototype.busy = function (button, on) {
    if (!button) return;
    button.disabled = on;
    button.setAttribute('aria-busy', on ? 'true' : 'false');
  };

  Instance.prototype.showError = function (message) {
    if (!this.error) return;
    this.error.textContent = message || 'Something went wrong. Please try again.';
    this.error.hidden = false;
  };

  Instance.prototype.hideError = function () {
    if (!this.error) return;
    this.error.hidden = true;
    this.error.textContent = '';
  };

  Instance.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
    if (this.veil && !this.veil.hidden) unlock();
    if (this.portal && this.portal.parentNode) this.portal.remove();
  };

  /* --------------------------------------------------------- scroll lock */

  var depth = 0;
  var offset = 0;

  function lock() {
    if (depth++) return;
    offset = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.top = -offset + 'px';
    document.documentElement.classList.add(LOCK);
  }

  function unlock() {
    if (!depth || --depth) return;
    document.documentElement.classList.remove(LOCK);
    document.body.style.top = '';
    window.scrollTo(0, offset);
  }

  /* -------------------------------------------------------- init/teardown */

  function init(container) {
    if (!container || container.getAttribute('data-kr-ready')) return;
    container.setAttribute('data-kr-ready', '1');
    var instance = new Instance(container);
    if (instance.root) live[instance.id] = instance;
  }

  function destroy(id) {
    if (!live[id]) return;
    live[id].destroy();
    delete live[id];
  }

  function boot(scope) {
    Array.prototype.forEach.call(
      (scope || document).querySelectorAll('[data-kr-section]'),
      init
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Theme editor and `shopify theme dev` hot reload both fire these.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var container = e.target.querySelector('[data-kr-section]');
    if (container) destroy(container.getAttribute('data-kr-section'));
  });
  /* Selecting the Upsell block in the editor opens the sheet so the merchant
     can see what they are editing. Deliberately scoped to that block rather
     than to the section: opening the modal whenever the section is selected
     would cover the page they are trying to edit.
     closest() rather than a lookup inside the section, because by now the
     sheet lives in <body> -- but it carries data-kr-section with it. */
  function instanceFor(node) {
    var el = node && node.closest && node.closest('[data-kr-section]');
    return el ? live[el.getAttribute('data-kr-section')] : null;
  }

  document.addEventListener('shopify:block:select', function (e) {
    var instance = instanceFor(e.target);
    if (instance && e.target.getAttribute('data-kr') === 'view-upsell') {
      instance.open();
    }
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var instance = instanceFor(e.target);
    if (instance && e.target.getAttribute('data-kr') === 'view-upsell') {
      instance.close();
    }
  });
})();
